import { MALDIVES_BUNDLE_DEFAULT_GUESTS, MALDIVES_BUNDLE_DEFAULT_PRICE_PER_PERSON } from 'constants/charterFlight'
import type { CalendarItemBundleData } from './MaldivesDirectSearchPage/hooks/types'

interface MaldivesBannerPriceDisplay {
  maldivesBundlePrice: number
  isMaldivesBundlePriceLoading: boolean
}

interface GetMaldivesBannerPriceDisplayParams {
  enabled: boolean
  bannerBundleData: CalendarItemBundleData
  guestCount: number
}

export function getMaldivesBannerPriceDisplay({
  enabled,
  bannerBundleData,
  guestCount,
}: GetMaldivesBannerPriceDisplayParams): MaldivesBannerPriceDisplay {
  const defaultTotalPrice = MALDIVES_BUNDLE_DEFAULT_PRICE_PER_PERSON * (guestCount || MALDIVES_BUNDLE_DEFAULT_GUESTS)

  if (!enabled) {
    return { maldivesBundlePrice: defaultTotalPrice, isMaldivesBundlePriceLoading: false }
  }
  if (bannerBundleData.fetching) {
    return { maldivesBundlePrice: defaultTotalPrice, isMaldivesBundlePriceLoading: true }
  }
  if (bannerBundleData.available && bannerBundleData.totalPrice > 0) {
    const total = bannerBundleData.memberTotalPrice ?? bannerBundleData.totalPrice
    return { maldivesBundlePrice: total, isMaldivesBundlePriceLoading: false }
  }
  return { maldivesBundlePrice: defaultTotalPrice, isMaldivesBundlePriceLoading: false }
}
